<template>
  <PageTemplate :class="componentClass" :title="metaTitle" :noContainer="true">
    <div>
      <v-container class="py-15">
        <v-row v-if="!smAndDown" justify="center" class="mt-5">
          <v-col cols="6" md="3" :key="key" v-for="(item, key) in items">
            <ServiceCard :item="item" />
          </v-col>
        </v-row>
        <CarouselWidget
          v-if="items.length && smAndDown"
          :items="items"
          :itemsToShow="{
            xs: 1.2,
            sm: 2,
            md: 2,
            lg: 3,
            xl: 3,
          }"
          :gap="20"
          dots
          class="my-10"
        >
          <template #item="{ item }">
            <ServiceCard :item="item" />
          </template>
        </CarouselWidget>
      </v-container>
    </div>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import ServiceCard from "../components/cards/ServiceCard.vue";
import CarouselWidget from "../components/widgets/CarouselWidget/Index.vue";
import { formatToURL } from "../utils/formatToURL";
/**
 * $route.meta = {
 *   mod: string; // Chave do módulo.
 *   ?title: string | (component) => string; // Título da página.
 *   ?params: Record<string, string> | (component) => Record<string, string>; // Parametros da requisição de dados
 * }
 */
export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    metaTitle() {
      const metaTitle = this.$route.meta.title;

      if (!metaTitle) {
        return this.$route.name;
      }

      if (typeof metaTitle === "function") {
        return metaTitle(this);
      } else {
        return metaTitle;
      }
    },
    mod() {
      return this.$route.meta.mod;
    },
    items() {
      return this.$rest(this.mod).list.map(({ id, img, title }) => ({
        img,
        title,
        to: `servicos/${formatToURL(title)}-${id}`,
      }));
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.$rest(this.mod).get();
  },
  components: {
    PageTemplate,
    ServiceCard,
    CarouselWidget,
  },
};
</script>
